import React from "react";
import { Box, Chip } from "@mui/material";
import logo from '../../assets/images/stream.png';
import TakeSurvey from "containers/pages/CANsurvey/TakeSurvey";

function SurveyPage() {
  return (
    <Box
         sx={{
           display: "flex",
           flexDirection: "column",
           minHeight: "95vh",
           position: "relative",
           px: 0,
           mx: 0,
         }}
       >

      <Box sx={{ flex: 1, width: "100%", height: "100%" }}>
        <TakeSurvey />
      </Box>

      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <Chip
          label="Powered by Stream Data Systems"
          variant="outlined"
          icon={
            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{ width: 20, height: 20 }}
            />
          }
        />
      </Box>
    </Box>
  );
}

export default SurveyPage;
